import 'js/src/libs/set-webpack-nonce';
import 'core-js/stable';
import 'js/src/libs/page-initialization';
import 'bootstrap';
import 'regenerator-runtime/runtime';

import 'css/src/global';

import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';

import { Urls } from 'js/src/client';
import PublicPagesTrim from 'js/src/components/common/public-pages/PublicPagesTrim';
import PageTerms from 'js/src/components/public-pages/PageTerms';
import PageTermsGetty from 'js/src/components/public-pages/PageTermsGetty';
import PageTermsShutterstock from 'js/src/components/public-pages/PageTermsShutterstock';
import PageTermsVideoblocks from 'js/src/components/public-pages/PageTermsVideoblocks';
import { ErrorReporter, Project } from 'js/src/libs/error-reporter';
import { renderComponent } from 'js/src/libs/redux-utils';

ErrorReporter.init(Project.FRONTEND);

const PageTermsContainer = React.memo(function PageTermsContainer() {
    return (
        <PublicPagesTrim headerBackgroundColor="White">
            <Router>
                <Switch>
                    <Route exact path={Urls.TERMS}>
                        <PageTerms />
                    </Route>
                    <Route exact path={Urls.TERMS_VIDEOBLOCKS}>
                        <PageTermsVideoblocks />
                    </Route>
                    <Route exact path={Urls.TERMS_GETTY}>
                        <PageTermsGetty />
                    </Route>
                    <Route exact path={Urls.TERMS_SHUTTERSTOCK}>
                        <PageTermsShutterstock />
                    </Route>
                </Switch>
            </Router>
        </PublicPagesTrim>
    );
});

renderComponent(PageTermsContainer);
